import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import config from '../../config'
import analytics from '../../helpers/analytics'
// import LinkedInTag from 'react-linkedin-insight'
import ReactPixel from '../../helpers/react-facebook-pixel-iyv'
import {
  Link
} from '../../components'
import Styles from './PetitionForm.css'

@CSSModules(Styles)
export default class PetitionForm extends Component {
  static propTypes = {
    petitionConfig: PropTypes.object.isRequired,
  }
  constructor(props){
    super(props)
    const petitionConfig = props.petitionConfig || {}
    this.state = {
      companyName: petitionConfig.companyName || null,
      petitionName: petitionConfig.petitionName || null,
      // linkedinTrackingId: petitionConfig.linkedinTrackingId || null,
      pardotFormUrl: petitionConfig.pardotFormUrl || null,
      pardotFirstNameId: petitionConfig.pardotFirstNameId || null,
      pardotLastNameId: petitionConfig.pardotLastNameId || null,
      pardotEmailId: petitionConfig.pardotEmailId || null
    }
  }

  componentDidUpdate() {
    this.myFormRef.reset();
  }

  log = () => {
    const { companyName, petitionName } = this.state

    if (companyName && petitionName) {
      analytics.event(
        analytics.eventStaffSupport(
          companyName,
          petitionName,
        )
      )
    }

    // if (config.linkedinPid && linkedinTrackingId) {
    //   LinkedInTag.track(linkedinTrackingId)
    // }

    if (config.fbPixelId && companyName && petitionName) {
      ReactPixel.track(
        'Lead',
        {
          content_name: `${companyName} ${petitionName}`
        }
      )
    }
  }

  render() {
    const {
      pardotFormUrl,
      pardotFirstNameId,
      pardotLastNameId,
      pardotEmailId
    } = this.state

    if (
      !pardotFormUrl ||
      !pardotFirstNameId ||
      !pardotLastNameId ||
      !pardotEmailId
    ) {
      return null
    }

    return (
      <div styleName='form-wrap'>
        <form
          styleName='form'
          acceptCharset='UTF-8'
          method='post'
          action={pardotFormUrl}
          target='signup_confirmation'
          ref={ (el) => this.myFormRef = el }
        >

          <label htmlFor={pardotFirstNameId}>
            First Name
          </label>
          <input styleName='input'
            name={pardotFirstNameId}
            type='text'
            placeholder=''
          />

          <label htmlFor={pardotLastNameId}>
            Last Name
          </label>
          <input styleName='input'
            name={pardotLastNameId}
            type='text'
            placeholder=''
          />

          <label htmlFor={pardotEmailId}>
            Email*<sup> (Required)</sup>
          </label>
          <input styleName='input'
            name={pardotEmailId}
            type='email'
            placeholder=''
            required
          />

          <div
            style={{
              position: 'absolute',
              left: '-9999px',
              top: '-9999px',
            }}
          >
            <label htmlFor="pardot_extra_field">Comments</label>
            <input
              type="text"
              id="pardot_extra_field"
              name="pardot_extra_field"
              tabIndex="-1"
            />
          </div>

          <button
            styleName='submit'
            type='submit'
            value=''
            onClick={this.log}
          >
            Sign the petition
          </button>
        </form>
        <p>
          We'll send you email updates on this campaign. <Link
            to={config.routes.legal}
            title='Privacy policy'
            xstrong
          >Read our privacy policy</Link>
        </p>
      </div>
    )
  }
}
